import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import ContributePage from './ContributePage';
import { AccessContext } from '../../Contexts/AccessContext';

const ProtectedContributorPage = ({ active }) => {
    const { canContribute, inProgress, accessLoading } = useContext(AccessContext);

    if (accessLoading) {
        // Optional: You can show a spinner or skeleton loader here
        return <div className="text-white text-center mt-10"><div className="flex items-center justify-center h-full w-full">
            <div className="w-12 h-12 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
        </div></div>;
    }

    if (canContribute && !inProgress) {
        return <ContributePage active={active} />;
    }

    return <Navigate to="/dashboard" />;
};

export default ProtectedContributorPage;
